import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/main.css";
import VueTilt from "vue-tilt.js";
import VueSweetalert2 from "vue-sweetalert2";
import GlobalPlugin from './plugins/globalPlugin';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ToggleSwitch from 'primevue/toggleswitch';
import 'primeicons/primeicons.css';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2);

const PrimevuePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

appInstance.use(PrimeVue, {
    theme: {
        preset: PrimevuePreset,
        options: {
            // Force manual dark mode control; won't follow system/browser dark mode
            darkModeSelector: '.app-dark'
        }
    }
});
appInstance.use(ToastService);
appInstance.component('Toast', Toast);
appInstance.component('ToggleSwitch', ToggleSwitch);

// Register the function & component globally
appInstance.use(GlobalPlugin);

appInstance.mount("#app");
